<div *ngIf="tags?.length" class="home-discover-filter-tags">
  <div
    *ngFor="let tag of tags"
    class="box-promo-tag"
    [reactComponent]="promoTagComponent"
    [props]="{ options: tag, enableAnimations: true }"
  ></div>
</div>
<div
  class="hover-opacity hoverable-animated image-tile"
  [reactComponent]="imageTileComponent"
  [props]="{
    imgUrl: imageUrl,
    altText: this.altText
  }"
></div>
